/** Common */

export const INTERNAL_SERVER_ERROR = 500;
export const SERVER_IS_UNAVAILABLE = 503;
export const INVALID_JWT = 813;
export const INVALID_VERIFICATION_TOKEN = 806;
export const EXPIRED_VERIFICATION_TOKEN = 807;
export const INVALID_REFRESH_TOKEN = 829;
export const INVALID_SESSION = 822;
export const INVALID_CREDENTIALS = 841;
export const INVALID_SECONDARY_CREDENTIALS = 842;
export const INACTIVE_USER_ERROR = 843;

export const INCORRECT_VERIFICATION_TOKENS = [
  INVALID_VERIFICATION_TOKEN,
  EXPIRED_VERIFICATION_TOKEN,
];

/** Organization */

export const ORGANIZATION_NOT_FOUND = 810;
export const INVALID_ORGANIZATION_ID = 838;

/** Policy id */

export const INVALID_POLICY_ID = 801;
export const LOGIN_FREEZED_DUE_TO_MANY_ATTEMPTS = 816;
export const POLICY_ID_NOT_FOUND = 828;

/** Phone number */

export const INVALID_PHONE_NUMBER = 804;

/** Email */

export const EMPTY_EMAIL = 811;
export const INVALID_EMAIL = 805;
export const UNKNOWN_EMAIL = 814;

/** OTP code */

export const EMPTY_OTP_CODE = 911;
export const INVALID_OTP_CODE = 912;
export const WRONG_OTP_CODE = 808;
export const EXPIRED_OTP_CODE = 809;


/** unused back-end errors */
export const USER_NOT_FOUND = 837;
export const GENERAL_VALIDATION_ERROR = 422;
export const BLOCKED_ID = 820;
export const PERMISSION_DENIED = 824;
export const DUPLICATION_OR_BREAKING_UNIQUE_CONSTANT = 409;

/** Appointment form */

export const ONE_APPOINTMENT_PER_SERVICE = 889;
export const OOH_APPOINTMENT = 883;
export const CAPACITY_IS_FULL = 890;

export const apiErrorMessagesMap = {
  [INVALID_POLICY_ID]: {
    id: 'Authentication.Login.Patient.Error.IncorrectCredentials',
    defaultMessage: '** Your credentials are incorrect. Please check your credentials and try again',
    field: 'externalId',
  },
  [INVALID_PHONE_NUMBER]: {
    id: 'Authentication.Login.Patient.Error.IncorrectCredentials',
    defaultMessage: '** Your credentials are incorrect. Please check your credentials and try again',
    field: 'phoneNumber',
  },
  [INVALID_CREDENTIALS]: {
    id: 'Authentication.Login.Patient.Error.IncorrectCredentials',
    defaultMessage: '** Your credentials are incorrect. Please check your credentials and try again',
    field: 'externalId',
  },
  [INACTIVE_USER_ERROR]: {
    id: 'Authentication.Login.Patient.Error.IncorrectCredentials',
    defaultMessage: '** Your credentials are incorrect. Please check your credentials and try again',
    field: 'externalId',
  },
  [INVALID_SECONDARY_CREDENTIALS]: {
    id: 'Authentication.Login.Patient.Error.Secondary.IncorrectCredentials',
    defaultMessage: '** Your credentials are incorrect. Please try again',
  },
};
